import NpsPage from '@/views/NpsPage/index.vue'

const NpsPageRouter = {
  path: '/nps-page',
  name: 'NpsPage',
  component: NpsPage,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default NpsPageRouter
